import React from 'react';
import {
  Backdrop, Box, Button, Fade, IconButton, Modal, Typography, alpha, useTheme,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { modalStyle } from '../../views/Customer/client.constants';

// Modal ฟอร์มเพิ่ม/แก้ไขผู้ติดต่อ — ใช้ร่วมกันได้ทั้งสองโหมด (title/subtitle/onSubmit/error ต่างกันไปตามผู้เรียก)
export default function ContactFormModal({
  open, onClose, title, subtitle, onSubmit, error, children,
}) {
  const theme = useTheme();

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 500 }}>
      <Fade in={open}>
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              gap: 2,
              px: 3,
              py: 1.75,
              background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
              borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              flexShrink: 0,
            }}
          >
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: theme.palette.primary.main, lineHeight: 1.3 }}>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.3 }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
            <IconButton size="small" onClick={onClose} sx={{ color: 'text.secondary', mt: -0.5 }}>
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box component="form" onSubmit={onSubmit} sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            <Box sx={{ flex: 1, overflowY: 'auto', p: 2.5 }}>
              {children}
              {error && (
                <Typography color="error" variant="body2" sx={{ mt: 2 }}>{error}</Typography>
              )}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, px: 3, py: 1.5, borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`, flexShrink: 0 }}>
              <Button variant="outlined" onClick={onClose} sx={{ borderRadius: 2, px: 3 }}>ยกเลิก</Button>
              <Button variant="contained" type="submit" sx={{ borderRadius: 2, px: 4 }}>บันทึก</Button>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
